if (!customElements.get('hv-video-hero')) {
  class HvVideoHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hv-hero__slide'));
      if (!this.slides.length) return;

      this.dots = Array.from(this.querySelectorAll('[data-hv-index]'));
      this.pauseBtn = this.querySelector('[data-hv-pause]');
      this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
      this.current = 0;
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._bindEvents();

      if (!this.reducedMotion) {
        this._loadAndPlayVisible(0);
        if (this.slides.length > 1) {
          this._startTimer();
        }
      }
    }

    _bindEvents() {
      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this._goTo(parseInt(dot.dataset.hvIndex, 10));
        });
      });

      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => this._togglePause());
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this._pauseAllVideos(this.current);
          clearInterval(this._timer);
        } else if (!this.paused) {
          this._loadAndPlayVisible(this.current);
          this._startTimer();
        }
      });
    }

    /**
     * Play only the video that is currently visible (respects
     * the mobile/desktop CSS show/hide switching).
     */
    _loadAndPlayVisible(index) {
      const slide = this.slides[index];
      if (!slide) return;
      slide.querySelectorAll('video').forEach(video => {
        // Skip videos hidden by CSS (mobile vs desktop media)
        if (getComputedStyle(video).display === 'none') return;
        if (video.readyState === 0) video.load();
        video.play().catch(() => {});
      });
    }

    _pauseAllVideos(index) {
      const slide = this.slides[index];
      if (!slide) return;
      slide.querySelectorAll('video').forEach(v => v.pause());
    }

    _goTo(index) {
      if (index === this.current || !this.slides[index]) return;
      const prev = this.current;
      this.current = index;

      this.slides[prev].classList.remove('is-active');
      this.slides[prev].setAttribute('aria-hidden', 'true');
      this.slides[index].classList.add('is-active');
      this.slides[index].setAttribute('aria-hidden', 'false');

      if (this.dots[prev]) {
        this.dots[prev].classList.remove('is-active');
        this.dots[prev].setAttribute('aria-selected', 'false');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('is-active');
        this.dots[index].setAttribute('aria-selected', 'true');
      }

      this._pauseAllVideos(prev);
      if (!this.paused && !this.reducedMotion) {
        this._loadAndPlayVisible(index);
        this._resetTimer();
      }
    }

    _next() {
      this._goTo((this.current + 1) % this.slides.length);
    }

    _startTimer() {
      this._timer = setInterval(() => this._next(), this.speed);
    }

    _resetTimer() {
      clearInterval(this._timer);
      this._startTimer();
    }

    _togglePause() {
      this.paused = !this.paused;
      this.toggleAttribute('data-paused', this.paused);
      this.pauseBtn.setAttribute(
        'aria-label',
        this.paused ? 'Play slideshow' : 'Pause slideshow'
      );

      if (this.paused) {
        clearInterval(this._timer);
        this._pauseAllVideos(this.current);
      } else if (!this.reducedMotion) {
        this._loadAndPlayVisible(this.current);
        this._startTimer();
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }
  }

  customElements.define('hv-video-hero', HvVideoHero);
}
